const getters = {
  menus: state => state.permission.menus,
  currentUser: state => state.user.currentUser,
  companyOrgs: state => state.user.companyOrgs,
  index: state => state.user.index,
  saleOrgs: state => state.user.saleOrgs,
  sIndex: state => state.user.sIndex,
  customerStorageOrg: state => state.user.customerStorageOrg,
  customerCompany: state => state.user.customerCompany
}
export default getters
